import { useQuery } from '@tanstack/react-query'

import { CURRENCY_NAMES, CurrenciesApi, currencyLabel } from '@/services/networks/currenciesApi'
import type { MultiSelectOption } from '../components/ui/multi-select'

/**
 * The currency codes the platform can handle for this network, from
 * `/v1/availablecurrencies`. Rarely changes, so it is cached for the session.
 */
export function useAvailableCurrencies() {
  const { data = [], isLoading } = useQuery({
    queryKey: ['availableCurrencies'],
    queryFn: () => CurrenciesApi.getAvailable(),
    staleTime: Infinity,
  })

  // The endpoint depends on today's exchange-rate feed; if it has nothing for
  // us, still offer the currencies we know names for rather than an empty list.
  const codes = data.length ? data.map((c) => c.currency) : Object.keys(CURRENCY_NAMES)
  const options: MultiSelectOption[] = codes.map((code) => ({
    value: code,
    label: currencyLabel(code),
  }))

  return { codes, options, isLoading }
}
